export const stateOptions = [
  { text: 'NSW', value: 'NSW' },
  { text: 'VIC', value: 'VIC' },
  { text: 'QLD', value: 'QLD' },
  { text: 'SA', value: 'SA' },
  { text: 'WA', value: 'WA' },
  { text: 'TAS', value: 'TAS' },
  { text: 'NT', value: 'NT' },
  { text: 'ACT', value: 'ACT' },
];
